import styled, { css } from 'styled-components'

export const Wrapper = styled.span`
  .label {
    /* font-weight: bold; */
    padding: 3px 6px;
    border-radius: 5px;
    font-size: var(--smallFont);
    flex-wrap: nowrap;
    /* background-color: var(--primary1); */
  }
`
